class WCSwiper extends WCDummy {
  #swiper;
  #wrapper;
  #slides;
  static script = false;

  static get tag() {
    return "wc-swiper";
  }

  constructor() {
    super({ tag: WCSwiper.tag });
    this.classList.add("swiper");

    this.#wrapper = this.querySelector(".swiper-wrapper");
    if (!this.#wrapper) {
      this.#wrapper = this.children[0];
      this.#wrapper.classList.add("swiper-wrapper");
    }

    this.#slides = this.querySelectorAll(".swiper-slide");

    if (this.navigation && this.active) {
      if (this.querySelector(".swiper-button-prev")) {
        this.querySelector(".swiper-button-prev").classList.add("custom");
      } else {
        const buttonPrev = document.createElement("div");
        buttonPrev.classList.add("swiper-button-prev");
        this.append(buttonPrev);
      }
      if (this.querySelector(".swiper-button-next")) {
        this.querySelector(".swiper-button-next").classList.add("custom");
      } else {
        const buttonNext = document.createElement("div");
        buttonNext.classList.add("swiper-button-next");
        this.append(buttonNext);
      }
    }

    if (this.pagination && this.active) {
      const pagination = document.createElement("div");
      pagination.classList.add("swiper-pagination");
      this.append(pagination);
    }

    if (this.scrollbar && this.active) {
      if (this.querySelector(".swiper-scrollbar")) {
        this.querySelector(".swiper-scrollbar").classList.add("custom");
      } else {
        const scrollbar = document.createElement("div");
        scrollbar.classList.add("swiper-scrollbar");
        this.append(scrollbar);
      }
    }
  }

  connectedCallback() {
    if (this.active) {
      if (!WCSwiper.script) {
        WCSwiper.script = import(
          "//www.bestfallschirm.com/cdn/shop/t/10/assets/esm-swiper-bundle.esm.browser.js?v=28931988941943071501725775256"
        );
      }
      WCSwiper.script.then(({ Swiper }) => {
        const thumbnailsSwiper =
          this.thumbnails && document.querySelector(this.thumbnails)?.swiper;
        if (thumbnailsSwiper && thumbnailsSwiper.isVertical()) {
          const updateThumbnailSize = () => {
            thumbnailsSwiper.el.style.maxHeight = `${this.offsetHeight}px`;
            thumbnailsSwiper.updateSize();
          };
          thumbnailsSwiper.on(
            "ready",
            debounce({
              callback: updateThumbnailSize,
              sleep: 300,
            })
          );
          thumbnailsSwiper.on(
            "resize",
            debounce({
              callback: updateThumbnailSize,
              sleep: 300,
            })
          );
        }
        this.swiper = new Swiper(this, {
          lazy: true,
          slidesPerView: "auto",
          ...(this.autoplay && {
            autoplay: {
              delay: this.autoplay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            },
          }),
          ...(this.index && {
            initialSlide: parseInt(this.index),
          }),
          ...(this.navigation && {
            navigation: {
              prevEl: ".swiper-button-prev",
              nextEl: ".swiper-button-next",
            },
          }),
          ...(this.pagination && {
            pagination: { clickable: true, el: ".swiper-pagination" },
          }),
          ...(this.scrollbar && {
            scrollbar: {
              el: ".swiper-scrollbar",
              draggable: true,
            },
          }),
          ...(this.vertical && {
            direction: "vertical",
            freeMode: true,
            slidesPerColumnFill: "column",
          }),
          ...(this.spacebetween && {
            spaceBetween: parseInt(this.spacebetween),
          }),
          ...(this.autoheight && {
            autoHeight: true,
          }),
          ...(thumbnailsSwiper && {
            thumbs: {
              swiper: thumbnailsSwiper,
            },
          }),
          ...(this.effect && {
            effect: this.effect,
            [`${this.effect}Effect`]: {
              slideShadows: false,
            },
          }),
        });
      });
    }
  }
  disconnectedCallback() {}

  get index() {
    return this.getAttribute("index");
  }

  get navigation() {
    return this.hasAttribute("navigation");
  }

  get scrollbar() {
    return this.hasAttribute("scrollbar");
  }

  get spacebetween() {
    return this.getAttribute("spacebetween");
  }

  get autoheight() {
    return this.hasAttribute("autoheight");
  }

  get pagination() {
    return this.hasAttribute("pagination");
  }

  get vertical() {
    return this.hasAttribute("vertical");
  }

  get autoplay() {
    return this.getAttribute("autoplay");
  }

  get effect() {
    return this.getAttribute("effect");
  }

  get thumbnails() {
    return this.getAttribute("thumbnails");
  }

  get swiper() {
    return this.#swiper;
  }

  set swiper(newSwiper) {
    this.#swiper = newSwiper;
  }

  get active() {
    return this.getAttribute("activate") !== "false" && this.#slides.length > 1;
  }
}

customElements.define(WCSwiper.tag, WCSwiper);
